<template>
    <div class="oneTicketDetails" v-if="show">
        <div class="ticketMsg">
            <!-- <p class="title">{{eventinfo.title}}</p>
            <div class="time">{{eventinfo.begintime}} - {{eventinfo.endtime}}</div>
            <p class="address">{{eventinfo.address}}</p> -->
            <div class="nameBox">
                <div class="ticketName">{{ticketinfo[0].ticketname}}</div>
                <div class="price">
                    <p class="ticketType" v-if="ticketinfo[0].seasonticketcount !== 1">{{ticketinfo[0].seasonticketcount}}人套票</p>
                    <p class="priceText">
                        ￥{{ticketinfo[0].uprice}}
                         <!-- x {{ticketinfo[0].seasonticketcount}} -->
                    </p>
                </div>
            </div>
            <div class="statusBox">
                <p>状态</p>
                <p :class="{'statusText': true, 'status1': ticketinfo[0].ticketstatus === 1, 'status3': ticketinfo[0].ticketstatus === 3}">{{ticketinfo[0].ticketstatusname}}</p>
            </div>
            <div class="dotted">
                <div class="line"></div>
                <div class="left"></div>
                <div class="right"></div>
            </div>
            <!-- <div class="participant">
                <div class="left">参加人</div>
                <div class="right">
                    <div class="textItem" v-for="(item, index) in ticketinfo[0].joinlist" :key="index">
                        <p class="name">{{item.joinername}}</p>
                        <p class="phoneNum">{{item.joinermobile}}</p>
                    </div>
                </div>
            </div>
            <div class="ticketNum" v-if="ticketinfo[0].ticketnolist.length && (ticketinfo[0].ticketstatus === 10 || ticketinfo[0].ticketstatus === 30 || ticketinfo[0].ticketstatus === 31)">
                <div class="left">票号</div>
                <div class="right">
                    <div class="item" v-for="(item, index) in ticketinfo[0].ticketnolist" :key="index">
                        <p>{{item.ticketno}}</p>
                    </div>
                </div>
            </div> -->
            <div class="joininfo_list">
                <div class="item" v-for="(item, index) in ticketinfo[0].joinlist" :key="index">
                    <div class="sort">参与人（{{index+1}}/{{ticketinfo[0].joinlist.length}}）</div>
                    <div class="msg" v-if="ticketinfo[0].ticketstatus === 10 || ticketinfo[0].ticketstatus === 30 || ticketinfo[0].ticketstatus === 31">
                        <div class="left">票号</div>
                        <div class="right">{{item.ticketno}}</div>
                    </div>
                    <div class="msg">
                        <div class="left">姓名</div>
                        <div class="right">{{item.joinername}}</div>
                    </div>
                    <div class="msg">
                        <div class="left">电话</div>
                        <div class="right">{{item.joinermobile}}</div>
                    </div>
                    <div class="dotted_line"></div>
                    <div class="form_box">
                        <div class="form_item_box" v-for="(obj, i) in item.formdatalist.slice(2)" :key="i">
                        <!-- <div class="form_item_box" v-for="(obj, i) in item.formdatalist" :key="i"> -->
                            <div class="form_item" v-if="obj.formvalue">
                                <div class="formname">{{obj.formname}}</div>
                                <div class="formvalue">{{obj.formvalue}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="dotted_line" v-if="index+1 !== ticketinfo[0].joinlist.length"></div>
                </div>
            </div>
        </div>
        <div class="checkAtyBtn">
            <van-button type="default" @click="checkAtyMsg">查看活动详情</van-button>
        </div>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import {getEventOrderTicket} from 'api/activeMy'
export default {
    name: 'oneTicketDetails',
    data() {
        return {
            eventinfo: {
                title: '',
                coveratturlid: '',
                begintime: '',
                endtime: '',
                address: ''
            },
            ticketinfo: {
                ticketname: '',
                uprice: '',
                seasonticketcount: '',
                ticketstatus: '',
                ticketstatusname: '',
                joinlist: [],
                ticketnolist: []
            },
            show: false,
            eventid: this.$route.query.eventid,
            itemid: this.$route.query.itemid,
            memo: '',
            ticketstatus: '',
            ticketstatusname: ''
        }
    },
    mounted() {
        this.getEventOrderTicket()
    },
    methods: {
        getEventOrderTicket() {
            this.setLoading(true)
            getEventOrderTicket({
                data: {eventid: this.eventid, itemid: this.itemid},
                success: data => {
                    this.setLoading(false)
                    this.eventinfo = data.data.eventinfo
                    document.title = this.eventinfo.title
                    this.ticketinfo = data.data.ticketlist
                    console.log(this.ticketinfo)
                    this.memo = data.data.memo
                    this.ticketstatus = data.data.ticketstatus
                    this.ticketstatusname = data.data.ticketstatusname
                    this.show = true
                    // this.ticketinfo.ticketstatus = 3
                    // console.log(this.ticketinfo)
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        checkAtyMsg() {
            this.$router.push({name: 'ActivityDetail', query: {eventid: this.eventid}})
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang="scss">
    .applyActivity {
        background: #F5F7FA;
    }
    .oneTicketDetails{
        padding: 0.6rem 0.6rem 0.2rem;
        // height: 100%;
        box-sizing: border-box;
        background: #F5F7FA;
        .ticketMsg{
            padding: 0.4rem 0.28rem 0.12rem;
            background: #fff;
            border-radius: 0.1rem;
            box-shadow:0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
            .title{
                width: 100%;
                font-size: 0.28rem;
                line-height: 0.40rem;
                font-weight: 550;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .time{
                font-size: 0.24rem;
                color: #666666;
                margin-top: 0.2rem;
            }
            .address{
                font-size: 0.24rem;
                color: #666666;
                margin-top: 0.12rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .dotted{
                padding: 0.3rem 0;
                position: relative;
                .line{
                    border-bottom: 0.02rem dashed #E5E5E5;
                }
                .left, .right{
                    width: 0.15rem;
                    height: 0.3rem;
                    background: #F5F7FA;
                    position: absolute;
                    top: 0.15rem;
                }
                .left{
                    left: -0.3rem;
                    border-radius: 0 0.15rem 0.15rem 0;
                }
                .right{
                    right: -0.3rem;
                    border-radius: 0.15rem 0 0 0.15rem;
                }
            }
            .nameBox{
                display: flex;
                justify-content: space-between;
                align-items: center;
                // padding-top: 0.2rem;
                padding-bottom: 0.32rem;
                .ticketName{
                    font-size: 0.28rem;
                    line-height: 0.4rem;
                    font-weight: 500;
                }
                .price{
                    display: flex;
                    align-items: center;
                    .ticketType{
                        color: #999999;
                        font-size: 0.2rem;
                        margin-right: 0.32rem;
                    }
                    .priceText{
                        font-size: 0.28rem;
                        color: #333333;
                    }
                }
            }
            .participant, .ticketNum{
                display: flex;
                justify-content: space-between;
                color: #666666;
                padding-bottom: 0.4rem;
                font-size: 0.28rem;
                .left{
                    line-height: 0.4rem;
                }
                .right{
                    .textItem, .item{
                        display: flex;
                        justify-content: space-between;
                        p{
                            line-height: 0.4rem;
                        }
                        .name{
                            margin-right: 0.5rem;
                        }
                    }
                }
            }
            .statusBox{
                display: flex;
                justify-content: space-between;
                color: #666666;
                font-size: 0.28rem;
                .statusText{
                    color: #0ABF53;
                }
                .status1{
                    color: #FFA904;
                }
                .status3{
                    color: #FF4747;
                }
            }
            .joininfo_list {
                .item {
                    .sort {
                        font-size: 0.28rem;
                        line-height: 0.4rem;
                        font-weight: bold;
                        margin-bottom: 0.32rem;
                    }
                    .msg {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 0.2rem;
                        line-height: 0.4rem;
                        .left {
                            font-size: 0.28rem;
                            line-height: 0.4rem;
                        }
                        .right {
                            font-size: 0.28rem;
                            color: #666666;
                        }
                    }
                    .dotted_line {
                        border-bottom: 0.02rem dashed #E5E5E5;
                        margin-bottom: 0.3rem;
                    }
                    .form_box {
                        .form_item {
                            .formname {
                                font-size: 0.28rem;
                                line-height: 0.4rem;
                                margin-bottom: 0.12rem;
                            }
                            .formvalue {
                                font-size: 0.28rem;
                                color: #999999;
                                line-height: 0.4rem;
                                margin-bottom: 0.2rem;
                            }
                        }
                    }
                }
            }
        }
        .checkAtyBtn{
            padding-top: 0.6rem;
            padding-bottom: 0.2rem;
            .van-button{
                width: 100%;
                height: 0.76rem;
                line-height: 0.76rem;
                border-radius: 0.4rem;
                color: #666666;
                font-size: 0.32rem;
            }
        }
    }
</style>